import { BodyContent, HeaderBar, MainTitle } from '../Main/Main.style';
import logo from '../../assets/images/logo2.svg';
import {
  ForgotDiv,
  Warper,
  Logo,
  Title,
  FomrDiv,
  Label,
  ForgotPasswordImg,
} from './../../ForgotPassword/ForgotPassword.style';
import { useForm, Controller } from 'react-hook-form';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { useAppDispatch, useAppSelector } from './../../../core/hooks';
import {
  loadingSelector,
  setLoading,
} from './../../../features/loading/loadingSlice';
import axiosInstance from '../../../core/axiosInstance';
import { useNavigate } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import img from './../../assets/images/loginbg.png';
import { InputText } from 'primereact/inputtext';
import { toast } from 'react-toastify';
import { LoginResponse } from '../../../features/auth/LoginResponse.interface';
import { classNames } from 'primereact/utils';

const ChangePassword = () => {
  const dispatch = useAppDispatch();
  dispatch(setLoading(false));
  const defaultValues = {
    old_password: '',
    new_password: '',
    new_password_confirmation: '',
  };

  //selectors
  const isLoading = useAppSelector(loadingSelector);
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({ defaultValues });

  //store actions to store creadentials to the store

  //navigator to navigate to home if login sucess
  const navigate = useNavigate();

  const onSubmit = async (data: any) => {
    dispatch(setLoading(true));
    if (data.password === data.confirmPassword) {
      await axiosInstance
        .post<any>('/dashboard/change-password', data)
        .then((res) => {
          navigate('/');
        })
        .catch((err: any) => {
          if (err.response.status === 422 || err.response.status === 403) {
          } else {
            toast.error(err.response?.data.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
          dispatch(setLoading(false));
        });
    } else {
      dispatch(setLoading(false));
    }
  };
  const getFormErrorMessage = (name: string) => {
    return (
      //@ts-ignore
      errors[`${name}`] && (
        <small className="p-error">
          {/* @ts-ignore */}
          {errors ? errors[`${name}`]?.message : null}
        </small>
      )
    );
  };

  return (
    <>
      <HeaderBar>
        <MainTitle></MainTitle>
      </HeaderBar>
      <BodyContent style={{ height: '80vh' }}>
        <FomrDiv style={{ width: '50%' }}>
          <Title>Set A New Password</Title>
          <div className="" style={{ position: 'relative', minWidth: '100%' }}>
            <div className="card">
              <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                <div className="p-field">
                  <Label
                    htmlFor="old_password"
                    className={classNames({
                      'p-error': errors[`old_password`],
                    })}
                  >
                    Old Password
                  </Label>
                  <Controller
                    name="old_password"
                    control={control}
                    rules={{
                      required: '*Required',
                      minLength: {
                        value: 6,
                        message: 'Enter at least 6 digits',
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <Password
                        className={classNames({
                          'p-invalid': fieldState.invalid,
                        })}
                        disabled={isLoading ? true : false}
                        id={field.name}
                        {...field}
                        placeholder="Old Password"
                        toggleMask
                        style={{ color: '#616161', opacity: '0.71' }}
                      />
                    )}
                  />
                  {getFormErrorMessage('old_password')}
                </div>
                <div className="p-field">
                  <Label
                    htmlFor="new_password"
                    className={classNames({
                      'p-error': errors[`new_password`],
                    })}
                  >
                    New Password
                  </Label>
                  <Controller
                    name="new_password"
                    control={control}
                    rules={{
                      required: '*Required',
                      minLength: {
                        value: 6,
                        message: 'Enter at least 6 digits',
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <Password
                        className={classNames({
                          'p-invalid': fieldState.invalid,
                        })}
                        disabled={isLoading ? true : false}
                        id={field.name}
                        {...field}
                        placeholder="New Password"
                        toggleMask
                        style={{ color: '#616161', opacity: '0.71' }}
                      />
                    )}
                  />
                  {getFormErrorMessage('new_password')}
                </div>

                <div className="p-field">
                  <Label
                    htmlFor="new_password_confirmation"
                    className={classNames({
                      'p-error': errors[`new_password_confirmation`],
                    })}
                  >
                    Confirm New Password
                  </Label>
                  <Controller
                    name="new_password_confirmation"
                    control={control}
                    rules={{
                      required: '*Required',
                      minLength: {
                        value: 6,
                        message: 'Enter at least 6 digits',
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <Password
                        className={classNames({
                          'p-invalid': fieldState.invalid,
                        })}
                        style={{ color: '#616161', opacity: '0.71' }}
                        disabled={isLoading ? true : false}
                        id={field.name}
                        {...field}
                        placeholder="Confirm New Password"
                        toggleMask
                      />
                    )}
                  />
                  {getFormErrorMessage('new_password_confirmation')}
                </div>

                <Button
                  type="submit"
                  label="Save Changes"
                  className="p-mt-2 submit-btn"
                  disabled={isLoading ? true : false}
                >
                  {isLoading ? (
                    <ProgressSpinner
                      style={{ height: '1.4rem', textAlign: 'center' }}
                    />
                  ) : null}
                </Button>
              </form>
            </div>
          </div>
        </FomrDiv>
      </BodyContent>
    </>
  );
};

export default ChangePassword;
